import { render, staticRenderFns } from "./BookingGuests.vue?vue&type=template&id=48da1448&"
import script from "./BookingGuests.vue?vue&type=script&lang=js&"
export * from "./BookingGuests.vue?vue&type=script&lang=js&"
import style0 from "./BookingGuests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports